import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ICiudad } from '../models/ciudad';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { IConfiguracionUnidad } from '../models/confUnidad';
import { IRazonEmpresa } from '../models/UnidadrazonEmpresa';
@Injectable({
  providedIn: 'root'
})
export class ConfunidadService {
  private apiUrl: string ='';
  constructor(private http: HttpClient) {
    this.apiUrl = environment.SUrlgApi + 'ConfUnidad';
  }

  getListadoConfUnidades(): Observable<IConfiguracionUnidad[]> {
    return this.http
      .get<IConfiguracionUnidad[]>(this.apiUrl)
      .pipe(retry(1), catchError(this.handleError));
  }
  getLstRazonSocial(): Observable<IRazonEmpresa[]> {
      return this.http
        .get<IRazonEmpresa[]>(this.apiUrl+'/GetRazonEmpresa/')
        .pipe(retry(1), catchError(this.handleError));
    }

  handleError(error:any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
        return errorMessage;
    });
  }
}
